module.exports = __webpack_public_path__ + "img/cb6b7cb.png";